
import VueI18n from 'vue-i18n';
import { ModalPlugin, FormCheckboxPlugin, FormFilePlugin } from 'bootstrap-vue';
require('./bootstrap');
// require('./admin');
// import 'bootstrap-vue/dist/bootstrap-vue.css';
import VTooltip from 'v-tooltip';
import vClickOutside from 'v-click-outside'
window.Vue = require('vue');

import messages from './vue-i18n-locales.generated';
VueScrollTo = require('vue-scrollto');

import VueMyToasts from 'vue-my-toasts'
// import 'vue-my-toasts/dist/vue-my-toasts.css'
import MyToast from './components/MyToast.vue';

// import { DatePicker as VueDatePicker }  from 'vue2-datepicker';
import ru from 'vue2-datepicker/locale/ru';
import en from 'vue2-datepicker/locale/en';
import fr from 'vue2-datepicker/locale/fr';

require('./app-old');

// VueDatePicker.locale('fr')

Vue.prototype.$role = window.IDP.role;

Vue.use(VTooltip);
Vue.use(vClickOutside);
Vue.use(VueScrollTo);
Vue.use(VueI18n);
Vue.use(ModalPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(FormFilePlugin);

Vue.use(VueMyToasts, {
    component: MyToast,
    options: {
        width: '560px',
        position: 'top-middle',
        padding: '2rem',
        duration: 1000000,
    }
})

Vue.directive('collapsible', {
    bind: function (el, binding) {
        el.transitionDuration = 350;
        if (binding.value) {
            setTimeout(function () {
                el.classList.remove("collapse");
                var height = window.getComputedStyle(el).height;
                el.classList.add('collapsing');
                el.offsetHeight;
                el.style.height = height;
                setTimeout(function () {
                    el.classList.remove("collapsing");
                    el.classList.add('collapse');
                    el.style.height = null;
                    el.classList.add('show');
                }, el.transitionDuration)
            }, 0);
        } else {
            el.style.height = window.getComputedStyle(el).height;
            el.classList.remove("collapse");
            el.classList.remove('show');
            el.offsetHeight;
            el.style.height = null;
            el.classList.add('collapsing');
            setTimeout(function () {
                el.classList.add('collapse');
                el.classList.remove("collapsing");
            }, el.transitionDuration)
        }
    },
    update: function (el, binding) {
        if (binding.oldValue != binding.value) {
            if (binding.value) {
                setTimeout(function () {
                    el.classList.remove("collapse");
                    var height = window.getComputedStyle(el).height;
                    el.classList.add('collapsing');
                    el.offsetHeight;
                    el.style.height = height;
                    setTimeout(function () {
                        el.classList.remove("collapsing");
                        el.classList.add('collapse');
                        el.style.height = null;
                        el.classList.add('show');
                    }, el.transitionDuration)
                }, 0);
            } else {
                el.style.height = window.getComputedStyle(el).height;
                el.classList.remove("collapse");
                el.classList.remove('show');
                el.offsetHeight;
                el.style.height = null;
                el.classList.add('collapsing');
                setTimeout(function () {
                    el.classList.add('collapse');
                    el.classList.remove("collapsing");
                }, el.transitionDuration)
            }
        }
    }
});


export const i18n = new VueI18n({
    locale: window.IDP.locale ? window.IDP.locale.toLowerCase() : 'ru',
    fallbackLocale: 'en',
    messages,
    pluralizationRules: {
        /**
         * @param choice {number} a choice index given by the input to $tc: `$tc('path.to.rule', choiceIndex)`
         * @param choicesLength {number} an overall amount of available choices
         * @returns a final choice index to select plural word by
         */
        'ru': function (choice, choicesLength) {
            // this === VueI18n instance, so the locale property also exists here

            if (choice === 0) {
                return 0;
            }

            const teen = choice > 10 && choice < 20;
            const endsWithOne = choice % 10 === 1;

            if (choicesLength < 4) {
                return (!teen && endsWithOne) ? 1 : 2;
            }
            if (!teen && endsWithOne) {
                return 1;
            }
            if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
                return 2;
            }

            return (choicesLength < 4) ? 2 : 3;
        }
    }
})


import vSelect from 'vue-select'
import EmployeeSearch from "./components/EmployeeSearch";
import EmployeeSidebar from "./components/EmployeeSidebar";
import Competences from "./components/Competences";
import ManagerPage from "./components/ManagerPage";
import EmployeePage from "./components/EmployeePage";
import AdminPage from "./components/admin/AdminPage";
import IDP from "./components/IDP";
import Catalog from "./components/Catalog";
import MyTreeFilter from "./components/MyTreeFilter";
import Providers from "./components/admin/Providers";

Vue.component('v-select', vSelect);
Vue.component('catalog', Catalog);
Vue.component('my-tree-filter', MyTreeFilter)
Vue.component('idp', IDP);
Vue.component('manager-page', ManagerPage);
Vue.component('employee-page', EmployeePage);
Vue.component('admin-page', AdminPage);
Vue.component('matrix-page', MatrixPage);
Vue.component('employee-search', EmployeeSearch);
Vue.component('employee-sidebar', EmployeeSidebar);
Vue.component('competences', Competences);
Vue.component('providers', Providers);
Vue.component('notifications', require('./components/Notifications.vue').default);

Vue.mixin({
    methods: {
        canSendToApproveIDP: function (currentRole, IDPStatus) {
            return (currentRole === 'employee' || currentRole === '') && IDPStatus === 'not_formed';
        },
        canApproveIDPAsManager: function (currentRole, IDPStatus) {
            return (currentRole === 'manager' || currentRole === 'fmanager') && IDPStatus === 'on_approval';
        },
        canApproveIDPAsHR: function (currentRole, IDPStatus) {
            return currentRole === 'hr' && (IDPStatus === 'on_approval' || IDPStatus === 'agreed_by_manager' || IDPStatus === 'not_formed');
        },
        validateIntegerInput(event) {
            if (event.data && event.data.match(/^[0-9]+$/) === null) {
                event.preventDefault();
            }
        },

        // FOR DOTS MENU
        // Назначить
        canAssignActivity(activity, idpStatus, role) {
            if ((role === 'hr' || role === 'manager' || role === 'fmanager') && activity.type !== 'wishes') {
                if (idpStatus === 'not_formed' || idpStatus === 'on_approval' || idpStatus === 'agreed_by_manager') {
                    return activity.status === 'rejected';
                }
                if (idpStatus === 'agreed_by_hr') return activity.status === 'rejected' || activity.status === 'canceled';
                if (idpStatus === 'agreed_by_hr' && activity.status === 'expired') {
                    return activity.type === 'course' || activity.type === 'event';
                }
            }
            return false;
        },
        // Отклонить
        canRejectActivity(activity, idpStatus, role) {
            if ((role === 'employee' || role === 'manager') && activity.type === 'individual') {
                if (idpStatus === 'agreed_by_hr' || idpStatus === 'agreed_by_manager') {
                    return activity.status === 'assigned';
                }
            }

            if ((role === 'hr' || role === 'manager' || role === 'fmanager') && activity.type !== 'wishes') {
                if (idpStatus === 'not_formed' || idpStatus === 'on_approval' || idpStatus === 'agreed_by_manager') {
                    return activity.status === 'assigned';
                }
                if (idpStatus === 'agreed_by_hr') {
                    return activity.status === 'assigned' || activity.status === 'inprogress' || activity.status === 'expired';
                }
            }
            if (role === 'hr' && activity.type === 'wishes') {
                if (activity.author_role === 'employee' || activity.author_role === 'manager' || activity.author_role === 'fmanager') {
                    return activity.status === 'pending' || activity.status === 'canceled';
                }
                if (activity.la_format === 'training') return activity.status === 'pending' || activity.status === 'canceled';
            }
            return false;
        },
        // Отменить или Отложить(для пожеланий)
        canCancelActivity(activity, idpStatus, role) {
            if ((role === 'hr' || role === 'manager' || role === 'fmanager') && activity.type !== 'wishes') {
                if (idpStatus === 'agreed_by_hr') {
                    return activity.status === 'assigned' || activity.status === 'inprogress' || activity.status === 'expired';
                }
            }
            if (role === 'hr' && activity.type === 'wishes') {
                if (activity.author_role === 'employee' || activity.author_role === 'manager' || activity.author_role === 'fmanager') {
                    return activity.status === 'pending' || activity.status === 'approved';
                }
                if (activity.la_format === 'training') return activity.status === 'pending';
            }
            return false;
        },
        // Удалить
        canRemoveActivity(activity, idpStatus, role) {
            console.log(activity)
            if (role === 'hr' && activity.type !== 'wishes') {
                return true;
            }

            if (role === 'employee' && activity.type !== 'wishes') {
                return idpStatus === 'not_formed'
                    && activity.group !== 'Обязательное обучение'
                    && activity.status === 'assigned';
            }

            if (role !== 'admin' && activity.author_role === 'employee' && activity.type !== 'wishes' && activity.type !== 'event') {
                if (activity.status === 'assigned' || activity.status === 'rejected'
                    || activity.status === 'expired' || activity.status === 'inprogress') {
                    return idpStatus === 'not_formed' || idpStatus === 'on_approval' || idpStatus === 'agreed_by_manager';
                }
            }

            if ((role === 'manager' || role === 'fmanager') && activity.author_role !== 'employee' && activity.type !== 'wishes' && activity.type !== 'event') {
                if (activity.status === 'assigned' || activity.status === 'rejected' || activity.status === 'expired' || activity.status === 'inprogress') {
                    return idpStatus === 'not_formed' || idpStatus === 'on_approval' || idpStatus === 'agreed_by_manager';
                }
            }

            return false;
        },
        // Удалить(для пожеланий)
        canRemoveWish(activity, idpStatus, role) {
            if (role === 'employee' && activity.type === 'wishes') {
                return idpStatus === 'not_formed'
            }
            if (role === 'manager' || role === 'fmanager') {
                if (activity.type === 'wishes' && (activity.author_role === 'manager' || activity.author_role === 'fmanager')) {
                    return activity.status === 'pending';
                }
                if (activity.la_format === 'training' && (activity.author_role === 'manager' || activity.author_role === 'fmanager')) {
                    return activity.status === 'pending';
                }
            }
            if (role === 'hr' && activity.type === 'wishes') {
                return true;
            }
            return false;
        },
        // Согласовать(для пожеланий)
        canApprove(activity, idpStatus, role) {
            if (role === 'hr' && activity.type === 'wishes') {
                if (activity.la_format === 'training') {
                    return activity.status === 'pending' || activity.status === 'canceled' || activity.status === 'rejected';
                }
                if (activity.author_role === 'employee' || activity.author_role === 'manager' || activity.author_role === 'fmanager') {
                    return activity.status === 'pending' || activity.status === 'canceled' || activity.status === 'rejected';
                }
            }
            return false;
        },
        // Пометить как “В процессе”
        canMarkAsInProgress(activity, idpStatus, role) {
            if ((role === 'hr' || role === 'employee'|| role === 'manager' || role === 'fmanager') && activity.type !== 'wishes') {
                if (activity.type === 'external' || activity.type === 'individual') {
                    return activity.status === 'assigned' && idpStatus === 'agreed_by_hr';
                }
            }
            if (role === 'hr' && activity.type === 'external') {
                if (idpStatus === 'not_formed' || idpStatus === 'on_approval' || idpStatus === 'agreed_by_manager') {
                    return activity.status === 'assigned' || activity.status === 'expired';
                }
            }

            return false;
        },
        // Пометить как пройденное
        canMarkAsDone(activity, idpStatus, role) {
            if ((role === 'hr' || role === 'employee') && (activity.type === 'external' || activity.type === 'individual')) {
                return activity.status === 'assigned' || activity.status === 'expired'
                    || activity.status === 'inprogress' || activity.status === 'notdone';
            }
            if ((role === 'hr' || role === 'employee'|| role === 'manager' || role === 'fmanager') && activity.type !== 'wishes') {
                if (activity.type === 'external' || activity.type === 'individual') {
                    if (idpStatus === 'agreed_by_hr') return activity.status === 'assigned' || activity.status === 'inprogress';
                    if (idpStatus === 'agreed_by_hr' && activity.status === 'expired'
                        && (role === 'hr'|| role === 'manager' || role === 'fmanager')) {
                        return true;
                    }
                }
            }
            return false;
        },
        // Пометить как не пройденное
        canMarkAsNotDone(activity, idpStatus, role) {
            if ((role === 'hr' || role === 'employee') && (activity.type === 'external' || activity.type === 'individual')) {
                return activity.status === 'assigned' || activity.status === 'expired'
                    || activity.status === 'inprogress' || activity.status === 'done';
            }
            if ((role === 'hr' || role === 'manager' || role === 'fmanager')  && activity.type !== 'wishes') {
                if (activity.type === 'external' || activity.type === 'individual') {
                    if (idpStatus === 'agreed_by_hr') {
                        return activity.status === 'assigned' || activity.status === 'inprogress' || activity.status === 'expired';
                    }
                }
            }
            return false;
        },
        // Установить новый срок
        canChangeDeadline(activity, idpStatus, role) {
            if ((role === 'hr' || role === 'manager' || role === 'fmanager')  && activity.type !== 'wishes') {
                if (idpStatus === 'not_formed' || idpStatus === 'agreed_by_manager') return activity.status === 'assigned';
                if (idpStatus === 'agreed_by_hr' && (activity.type === 'course' || activity.type === 'event')) {
                    return activity.status === 'assigned' || activity.status === 'available' || activity.status === 'expired';
                }
                if (idpStatus === 'agreed_by_hr' && (activity.type === 'external' || activity.type === 'individual')) {
                    return activity.status === 'assigned' || activity.status === 'inprogress' || activity.status === 'expired';
                }
            }
            if (role === 'employee' && activity.type !== 'wishes') {
                if (idpStatus === 'not_formed' || idpStatus === 'on_approval' || idpStatus === 'agreed_by_manager') {
                    return activity.status === 'assigned';
                }
                if (idpStatus === 'agreed_by_hr' && activity.type === 'individual' && activity.author_role === 'employee') {
                    return activity.status === 'assigned' || activity.status === 'inprogress' || activity.status === 'expired';
                }
            }
            return false;
        },
        // Прикрепить файл
        canAttachFiles(activityType) {
            return activityType !== 'wishes';
        },

        canDuplicate(items, role) {
            const activity = Object.values(items)[0];
            return Object.values(items).length === 1
                && (activity.type === 'individual' || activity.type === 'external')
                && role === 'hr';
        },

        canDuplicateCm(type, role) {
            return role === 'hr' && (type === 'individual' || type === 'external');
        },

        // FOR ACTIONS BUTTON (MASS ACTIONS)
        canMassAssign(items, idpStatus, role) {
            let isCan = true;
            Object.values(items).forEach(item => {
                if (this.canAssignActivity(item, idpStatus, role) === false) isCan = false;
            })
            return isCan;
        },
        canMassReject(items, idpStatus, role) {
            let isCan = true;
            Object.values(items).forEach(item => {
                if (this.canRejectActivity(item, idpStatus, role) === false) isCan = false;
            })
            return isCan;
        },
        canMassCancel(items, idpStatus, role) {
            let isCan = true;
            Object.values(items).forEach(item => {
                if (this.canCancelActivity(item, idpStatus, role) === false) isCan = false;
            })
            return isCan;
        },
        canMassMarkInProgress(items, idpStatus, role) {
            let isCan = true;
            Object.values(items).forEach(item => {
                if (this.canMarkAsInProgress(item, idpStatus, role) === false) isCan = false;
            })
            return isCan;
        },
        canMassDone(items, idpStatus, role) {
            let isCan = true;
            Object.values(items).forEach(item => {
                if (this.canMarkAsDone(item, idpStatus, role) === false) isCan = false;
            })
            return isCan;
        },
        canMassNotDone(items, idpStatus, role) {
            let isCan = true;
            Object.values(items).forEach(item => {
                if (this.canMarkAsNotDone(item, idpStatus, role) === false) isCan = false;
            })
            return isCan;
        },
        canMassDeadlines(items, idpStatus, role) {
            let isCan = true;
            Object.values(items).forEach(item => {
                if (this.canChangeDeadline(item, idpStatus, role) === false) isCan = false;
            })
            return isCan;
        },
        canMassAttachFiles(items) {
            let isCan = true;
            Object.values(items).forEach(item => {
                if (this.canAttachFiles(item.type) === false) isCan = false;
            })
            return isCan;
        },
        canMassRemoveActivities(items, idpStatus, role) {
            let isCan = true;
            Object.values(items).forEach(item => {
                if (this.canRemoveActivity(item, idpStatus, role) === false) isCan = false;
            })
            return isCan;
        },
        canMassRemoveWishes(items, idpStatus, role) {
            let isCan = true;
            Object.values(items).forEach(item => {
                if (this.canRemoveWish(item, idpStatus, role) === false) isCan = false;
            })
            return isCan;
        },
        canMassApprove(items, idpStatus, role) {
            let isCan = true;
            Object.values(items).forEach(item => {
                if (this.canApprove(item, idpStatus, role) === false) isCan = false;
            })
            return isCan;
        },
    }
})

Vue.prototype.IDP = window.IDP;


import VueRouter from "vue-router";
import MatrixPage from "./components/admin/MatrixPage";

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes: [
        {path: '/manager/employee/:pernumber', name: 'manager-employee', component: IDP},
        {path: '/fmanager/employee/:pernumber', name: 'fmanager-employee', component: IDP},
        {path: '/hr/employee/:pernumber', name: 'hr-employee', component: IDP},
        {path: '/admin/employee/:pernumber', name: 'admin-employee', component: IDP},
        {path: '/employee', name: 'employee', component: IDP},
        {path: '/catalog', name: 'catalog', component: Catalog},
    ]
})

$(document).ready(function () {

    if ($('#catalog-component').length) {
        const app = new Vue({
            i18n,
            router,
            el: '#catalog-component'
        });
    }

    if ($('#manager-page').length) {
        const app = new Vue({
            i18n,
            router,
            el: '#manager-page'
        });
    }
    if ($('#admin-page').length) {
        const app = new Vue({
            i18n,
            router,
            el: '#admin-page'
        });
    }
    if ($('#employee-page').length) {
        const app = new Vue({
            i18n,
            router,
            el: '#employee-page'
        });
    }

    if ($('#admin-competences').length) {
        const app = new Vue({
            i18n,
            el: '#admin-competences'
        });
    }

    if ($('#admin-providers').length) {
        const app = new Vue({
            i18n,
            el: '#admin-providers'
        });
    }
    if ($('#admin-matrix').length) {
        const app = new Vue({
            i18n,
            router,
            el: '#admin-matrix'
        });
    }

    if ($('#idp').length) {
        const app = new Vue({
            i18n,
            router,
            el: '#idp'
        });
    }
});
